<template>
  <el-table
    size="mini"
    border
    :data="result"
    empty-text="Нет данных"
    show-summary
    sum-text=" "
  >
    <el-table-column label="" width="60" v-slot="scope">
      {{scope.row.name}}
    </el-table-column>
    <el-table-column label="Факт, чел." prop="count" v-slot="scope">
      {{scope.row.count}}
    </el-table-column>
    <el-table-column label="Фактическое распределение, %" v-slot="scope">
      {{scope.row.fact_distribution}}
    </el-table-column>
    <el-table-column label="Нормальное распределение, %"  v-slot="scope">
      {{scope.row.normal_distribution}}
    </el-table-column>
  </el-table>

</template>

<script>


import TotalEvaluateSelectColumn from "@/componentsCompany/smz/tableColumnTemplates/TotalEvaluateSelectColumn.vue";
import RouterLinkToCardColumnTemplate
  from "@/componentsCompany/smz/tableColumnTemplates/cards/RouterLinkToCardColumnTemplate.vue";
import CurrentStageColumnTemplate from "@/components/tableColumnTemplates/cards/StatusColumnTemplate.vue";

export default {
  name: "LevelCalibrationTable",
  components: { CurrentStageColumnTemplate, RouterLinkToCardColumnTemplate, TotalEvaluateSelectColumn },
  props: {
    result: {type: Array, required: true},
  },
  data() {
    return {
    }
  },

  methods: {},
}
</script>

<style lang="scss">

</style>